import { render, staticRenderFns } from "./list_of_briefings.vue?vue&type=template&id=58901024"
import script from "./list_of_briefings.vue?vue&type=script&lang=js"
export * from "./list_of_briefings.vue?vue&type=script&lang=js"
import style0 from "./list_of_briefings.vue?vue&type=style&index=0&id=58901024&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports